import styled from 'styled-components';

export const PublicWrapper = styled.div(() => ({
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  height: '100vh',
  alignItems: 'center',
}));
